import React from 'react';
import withSettingsContext from 'SettingsContext';
import { MODERN_THEME } from 'styled/constants';
import { props, defaultProps } from './CheckboxInput.props';
import { StyledInput } from './CheckboxInput.styled';
import { StyledInputModern } from './CheckboxInput.styled.modern';

class CheckboxInput extends React.Component {
  static propTypes = props;
  static defaultProps = defaultProps;
  state = { stateChecked: this.props.checked || false };

  changeState = () => {
    const { onChange } = this.props;
    const status = !this.state.stateChecked;
    this.setState({ stateChecked: status });
    return onChange(status);
  };

  componentWillReceiveProps(prevProps, prevState) {
    this.setState({ ...prevState, stateChecked: prevProps.checked });
  }

  getTemplateStyledComponent() {
    if (this.props.settings.theme.template === MODERN_THEME) {
      return StyledInputModern;
    }
    return StyledInput;
  }

  render() {
    const {
      inputClass,
      className,
      wrapperId,
      color,
      fontSize,
      error,
      label,
      text,
      disable,
    } = this.props;

    const { stateChecked } = this.state;

    const StyledComponent = this.getTemplateStyledComponent();

    return (
      <StyledComponent
        color={color}
        fontSize={fontSize}
        id={wrapperId}
        className={className}
        error={error}
        disabled={disable}
      >
        {label && <div className="label">{label}</div>}
        <div className="input-wrapper">
          <label>
            <input
              checked={stateChecked}
              className={`${inputClass || ''} checkbox`}
              type="checkbox"
              onChange={this.changeState}
            />
            <span className={`${disable ? 'disabled' : 'check-mark'}`} />
            {text}
          </label>
        </div>
        {error && <div className="error">{error}</div>}
      </StyledComponent>
    );
  }
}
export default withSettingsContext(CheckboxInput);
